module.exports = __webpack_public_path__ + "static/media/ic-copy.5dd11907.svg";